import { showApiErrors } from '@/utils';
import { createSlice, isPending, isRejected, PayloadAction } from '@reduxjs/toolkit';
import { TGetRedirectsQuery } from '../helpers/types';
import { createRedirect, deleteRedirect, getRedirect, getRedirects, updateRedirect } from './actionCreators';
import { initialState, REDIRECTS_SLICE_NAME, RedirectsListState } from './models';

export const slice = createSlice({
  name: REDIRECTS_SLICE_NAME,
  initialState,
  reducers: {
    resetRedirectsState() {
      return initialState;
    },
    changeQuery: (state: RedirectsListState, action: PayloadAction<TGetRedirectsQuery>) => {
      state.query = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getRedirects.fulfilled, (state: RedirectsListState, action) => {
        state.redirectsList = action.payload;
        state.isLoading = false;
      })
      .addCase(createRedirect.fulfilled, (state: RedirectsListState) => {
        state.isLoading = false;
      })
      .addMatcher(
        isPending(createRedirect, deleteRedirect, getRedirect, getRedirects, updateRedirect),
        (state: RedirectsListState) => {
          state.isLoading = true;
          state.error = null;
        },
      )
      .addMatcher(
        isRejected(createRedirect, deleteRedirect, getRedirect, getRedirects, updateRedirect),
        (state: RedirectsListState, action) => {
          const { error } = action;
          state.isLoading = false;
          state.error = error;

          showApiErrors(error);
        },
      );
  },
});

export const { resetRedirectsState, changeQuery } = slice.actions;

export default slice.reducer;
